/* eslint-disable */
export default (state = 'MDT', action = {}) => {
    function translationTitle(title, defaultTitle) {
        var t = typeof window.t === 'function' ? window.t : false;
        return !!t ? t(title) : defaultTitle;
    }
    switch (action.type) {
        case 'HOME':
            return translationTitle('mdt.home', 'MDT Home');
        case 'USER':
            return translationTitle('mdt.user', 'MDT User');
        case 'CATALOG':
            return translationTitle('mdt.catalog', 'MDT Catalog');
        case 'CART':
            return translationTitle('mdt.cart', 'MDT Cart');
        case 'DRAFTORDERS':
            return translationTitle('mdt.draftOrder', 'Draft Order');
        case 'ORDERHISTORY':
            return translationTitle('mdt.orderHistory', 'MDT Order History');
        case 'RMAHISTORY':
            return translationTitle('mdt.rmaHistory', 'MDT RMA History');
        case 'DELIVERYNOTERETRIEVAL':
            return translationTitle('mdt.deliveryNoteRetrieval', 'Delivery Note Retrieval');
        case 'PRODUCTDETAILS':
            return translationTitle('mdt.productDetails', 'MDT Product Details');
        case 'ORDERDETAILS':
            return translationTitle('mdt.orderDetails', 'MDT Order Details');
        case 'CHECKOUT':
            return translationTitle('mdt.checkout', 'MDT Checkout');
        case 'ORDERCONFIRMATION':
            return translationTitle('mdt.orderConfirmation', 'MDT Order Confirmation');
        case 'INVENTORYCHECKIN':
            return translationTitle('mdt.inventoryCheckin', 'MDT Inventory Checkin');
        case 'INVENTORYCHECKOUT':
            return translationTitle('mdt.inventoryCheckout', 'MDT Inventory Checkout');
        case 'FINDMYSALESREP':
            return translationTitle('mdt.findMySalesrep', 'Find My Salesrep');
        case 'USERGUIDES':
            return translationTitle('mdt.userGuides', 'User Guides');
        case 'POPENDING':
            return translationTitle('mdt.poPending', 'Po Pending');
        case 'REPORTORDERDISCREPANCY':
            return translationTitle('mdt.reportOrder', 'Report Order');
        case 'BILLANDREPLACE':
            return translationTitle('mdt.billAndReplace', 'Bill and Replace');
        case 'TRANSACTION':
            return translationTitle('mdt.transactions', 'Transactions');
        case 'RMAREQUEST':
              return translationTitle('mdt.rmaRequest', 'Create RMA Request');
        case 'CREATERMA':
            return translationTitle('mdt.rmaCreate', 'Create RMA');
        case 'RMADETAIL':
            return translationTitle('mdt.rmaDetail', 'RMA Detail');
        case 'INVOICEHISTORY':
            return translationTitle('mdt.invoices', 'Invoices');
        case 'TERMSANDCONDITIONS':
            return translationTitle('mdt.termsAndConditions', 'Terms and Conditions');
        case 'HELP':
            return translationTitle('mdt.help', 'MDT Help');
        case 'INVENTORYSPECIALCHECKIN':
            return translationTitle('mdt.inventorySpecialCheckin', 'Inventory Special Checkin');
        case 'RETURNHISTORY':
            return translationTitle('mdt.returnableOrders', 'Returnable Orders');
        case 'NEWWARRANTYCLAIM':
            return translationTitle('mdt.newWarrantyClaim', 'New Warranty Claim');
        case 'TRAINING':
            return translationTitle('mdt.training', 'Training');
        case 'ITCHISTORYREPORT':
            return translationTitle('mdt.ITCHistoryReport', 'ITC History Report');
        case 'ITCACCOUNTSTATEMENT':
            return translationTitle('mdt.ITCAccountStatement', 'ITC Account Statement');
        case 'ITCPAYMENTUSAGEDETAIL':
            return translationTitle('mdt.ITCPaymentUsageDetail', 'ITC Payment Usage Detail');
        case 'ACCOUNTINVOICEDETAIL':
            return translationTitle('mdt.accountInvoiceDetail', 'ITC Accounting Invoice Detail');
        case 'RETURNCHECKOUT':
            return translationTitle('mdt.return', 'Return');
        case 'MANAGESUBMISSIONS':
            return translationTitle('mdt.manageSubmissions', 'Manage Submissions');
        case 'SUBMISSIONDETAIL':
            return translationTitle('mdt.submissionDetail', 'Submission Detail');
        case 'SALESOUTRECORD':
            return translationTitle('mdt.salesOutRecord', 'Sales Out Record');
        case 'INVENTORYRECORD':
            return translationTitle('mdt.inventoryRecord', 'Inventory Record');
        case 'ENDCUSTOMERRECORD':
            return translationTitle('mdt.endCustomerRecord', 'Add New End Customer');
        case 'SUBMISSIONSTATUSREPORT':
            return translationTitle('mdt.submissionStatusReport', 'Submission Status Report');
        case 'SERVICEREQUEST':
            return translationTitle('mdt.servicerequest', 'Service Request');
        case 'SERVICEREQUESTDETAILS':
            return translationTitle('mdt.servicerequestdetails', 'Service Request Details');
        case 'CONSUMPTIONSUMMARY':
            return translationTitle('mdt.consumptionSummary', 'MDT Consumption Summary');
        case 'REPORTDISCREPANCYSUMMARY':
            return translationTitle(
                'mdt.reportDiscrepancySummary',
                'MDT Report Discrepancy Summary'
            );
        case 'ORDERSPENDINGAPPROVAL':
            return translationTitle('mdt.ordersPendingApproval', 'MDT Orders Pending Approval');
        case 'EQUIPMENTOVERVIEW':
            return translationTitle('mdt.equipmentOverview', 'Equipment Overview');
        case 'EQUIPMENTDETAILS':
            return translationTitle('mdt.equipmentDetails', 'Equipment Details');
        case 'ACUTECAREMONITORING':
            return translationTitle('mdt.acuteCareMonitoring', 'Acute Care Monitoring');
        default:
            return state;
    }
};
